export default {
  DR: 'DR',
  MR: 'MR',
  MRS: 'MRS',
  MS: 'MS',
  MIS: 'MIS',
};
